export const sites: Record<string, string> = {
  'Always on': 'Toujours actif',
  'Always on for every shift': 'Toujours actif pour chaque vacation',
  'Automatic (alone or {start}-{end})': 'Automatique (seul ou de {start} à {end})',
  'Automatic monitoring applies when only one guard is clocked in at the site or during the configured local night window. Shift overrides take priority.':
    'La surveillance automatique s’applique lorsqu’un seul agent est pointé sur le site ou pendant la plage de nuit locale configurée. Les exceptions de vacation sont prioritaires.',
  'Automatic: working alone or at night': 'Automatique : travail isolé ou de nuit',
  'Default site policy': 'Politique par défaut du site',
  'Edit welfare': 'Modifier le bien-être',
  'Edit welfare-check policy': 'Modifier la politique de contrôle de bien-être',
  'Failed to update welfare-check policy': 'Impossible de mettre à jour la politique de contrôle de bien-être',
  'Night ends': 'Fin de la nuit',
  'Night start and end cannot be the same.': 'Le début et la fin de la nuit ne peuvent pas être identiques.',
  'Night starts': 'Début de la nuit',
  'Off by default': 'Désactivé par défaut',
  'Qualifying guards are prompted every 60 minutes and have 10 minutes to check in. Individual shifts can override this default.':
    'Les agents concernés sont sollicités toutes les 60 minutes et disposent de 10 minutes pour confirmer leur sécurité. Chaque vacation peut remplacer ce réglage par défaut.',
  'Save welfare policy': 'Enregistrer la politique de bien-être',
  'Updated welfare-check policy for {name}.': 'Politique de contrôle de bien-être mise à jour pour {name}.',
  'Welfare checks': 'Contrôles de bien-être',
  'Address': 'Adresse',
  'Archive Client': 'Archiver le client',
  'Billing': 'Facturation',
  'Build and manage patrol routes, checkpoints, and QR verification for any site.':
    'Créez et gérez les itinéraires de ronde, les points de contrôle et la vérification par QR code pour chaque site.',
  'Choose a country first': 'Choisissez d’abord un pays',
  'Click and hold a vertex to reposition it. Right-click a vertex to delete it.':
    'Cliquez sur un sommet et maintenez-le pour le repositionner. Faites un clic droit sur un sommet pour le supprimer.',
  'Click anywhere on the map to drop a pin.':
    'Cliquez n’importe où sur la carte pour placer un repère.',
  'Click the map to add boundary points. Click and hold any point to drag it, and right-click a point to delete it.':
    'Cliquez sur la carte pour ajouter des points de limite. Cliquez sur un point et maintenez-le pour le déplacer, puis faites un clic droit pour le supprimer.',
  'Client lifecycle': 'Cycle de vie du client',
  'Create Client': 'Créer le client',
  'Manage Clients': 'Gérer les clients',
  'Save Changes': 'Enregistrer les modifications',
  'Saving…': 'Enregistrement…',
  'Confirm Location': 'Confirmer l’emplacement',
  'Contact': 'Contact',
  'Covered': 'Couvert',
  'Delete Client': 'Supprimer le client',
  'Delete site': 'Supprimer le site',
  'Draw the boundary point-by-point on the map.':
    'Tracez la limite point par point sur la carte.',
  'Draw the operational boundary point-by-point on the map.':
    'Tracez la limite opérationnelle point par point sur la carte.',
  'Duty board dates and times will follow this local timezone.':
    'Les dates et heures du tableau de service suivront ce fuseau horaire local.',
  'Duty board slots can only be created inside this window. End times earlier than start roll into the next day.':
    'Les créneaux du tableau de service ne peuvent être créés que dans cette plage. Une heure de fin antérieure à l’heure de début est reportée au jour suivant.',
  'Edit coverage': 'Modifier la couverture',
  'Edit coverage window': 'Modifier la plage de couverture',
  'Edit site geofence bounds': 'Modifier les limites géorepérées du site',
  'Full coverage': 'Couverture complète',
  'Full coverage days': 'Jours entièrement couverts',
  'Geofence Radius (metres)': 'Rayon de géorepérage (mètres)',
  'Guards will be evaluated against this circle when no custom polygon is in use.':
    'La position des agents sera évaluée par rapport à ce cercle lorsqu’aucun polygone personnalisé n’est utilisé.',
  'No coverage': 'Aucune couverture',
  'No coverage days': 'Jours sans couverture',
  'No results': 'Aucun résultat',
  'No shift instances overlap this day.':
    'Aucune vacation ne chevauche cette journée.',
  'No shift overlap on that day': 'Aucun chevauchement de vacation ce jour-là',
  'No sites found for this client yet. Add a site to get started.':
    'Aucun site trouvé pour ce client. Ajoutez un site pour commencer.',
  'No sites match the current filters.':
    'Aucun site ne correspond aux filtres actuels.',
  'No uncovered windows': 'Aucune plage non couverte',
  'No uncovered windows for this day.': 'Aucune plage non couverte pour cette journée.',
  'Open Patrol Builder': 'Ouvrir l’éditeur de ronde',
  'Open Sites': 'Ouvrir les sites',
  'Overnight': 'De nuit',
  'Partial coverage': 'Couverture partielle',
  'Partial coverage days': 'Jours partiellement couverts',
  'Patrols & Posts': 'Rondes et postes',
  'Pick Location on Map': 'Choisir l’emplacement sur la carte',
  'Pick on Map': 'Choisir sur la carte',
  'Radius': 'Rayon',
  'Radius (meters)': 'Rayon (mètres)',
  'Radius mode requires a site pin. Site geofence bounds mode can derive the site center from the polygon if needed.':
    'Le mode rayon nécessite un repère de site. Le mode limites géorepérées peut déterminer le centre du site à partir du polygone si nécessaire.',
  'Required coverage': 'Couverture requise',
  'Required licence': 'Licence requise',
  'Restore Client': 'Restaurer le client',
  'Search Address': 'Rechercher une adresse',
  'Search…': 'Rechercher…',
  'Select a client from the list to view and manage its sites.':
    'Sélectionnez un client dans la liste pour consulter et gérer ses sites.',
  'Select a country…': 'Sélectionner un pays…',
  'Selected location': 'Emplacement sélectionné',
  'Shift instances': 'Vacations',
  'Show only sites with gaps': 'Afficher uniquement les sites avec des lacunes',
  'Site Coverage Gaps': 'Lacunes de couverture du site',
  'Site geofence bounds': 'Limites géorepérées du site',
  'Site geofence bounds builder': 'Éditeur des limites géorepérées du site',
  'Site location will be derived from the geofence bounds centroid.':
    'L’emplacement du site sera déterminé à partir du centre des limites géorepérées.',
  'Site Name *': 'Nom du site *',
  'Site timezone': 'Fuseau horaire du site',
  'Sites with gaps': 'Sites présentant des lacunes',
  'Some hours uncovered': 'Certaines heures non couvertes',
  'Start clicking on the map to place the first boundary point.':
    'Cliquez sur la carte pour placer le premier point de limite.',
  'Start typing an address or place…': 'Commencez à saisir une adresse ou un lieu…',
  'Address suggestions': 'Suggestions d’adresses',
  'Searching…': 'Recherche…',
  'Address search is unavailable right now.': 'La recherche d’adresse est indisponible pour le moment.',
  'No addresses match “{query}” in {country}.': 'Aucune adresse ne correspond à « {query} » (pays : {country}).',
  'No addresses match “{query}”.': 'Aucune adresse ne correspond à « {query} ».',
  'Drop the pin on the map instead': 'Placer plutôt le repère sur la carte',
  'That address could not be loaded. Try again, or drop the pin on the map.':
    'Impossible de charger cette adresse. Réessayez ou placez le repère sur la carte.',
  'Searching in {country}. Change the country above to search elsewhere.':
    'Recherche limitée à : {country}. Changez le pays ci-dessus pour chercher ailleurs.',
  'Searching every country. Choose a country above to narrow it down.':
    'Recherche dans tous les pays. Choisissez un pays ci-dessus pour affiner.',
  'Taken from {client}. It decides which licence types and timezone apply.':
    'Repris de {client}. Il détermine les types de licence et le fuseau horaire applicables.',
  'New sites for this client start here, and their address search looks here first.':
    'Les nouveaux sites de ce client commencent dans ce pays, et la recherche d’adresse s’y limite d’abord.',
  'Summary': 'Synthèse',
  'The polygon is stored directly on the site and shown while patrols are being plotted.':
    'Le polygone est enregistré directement sur le site et affiché pendant le tracé des rondes.',
  'The polygon is stored directly on the site so guard apps can read the full boundary.':
    'Le polygone est enregistré directement sur le site afin que les applications des agents puissent lire l’intégralité de la limite.',
  'This country uses multiple timezones, so choose the one used by this site.':
    'Ce pays utilise plusieurs fuseaux horaires ; choisissez celui du site.',
  'Total shifts': 'Nombre total de vacations',
  'Uncovered': 'Non couvert',
  'Uncovered windows': 'Plages non couvertes',
  'Understaffed shifts': 'Vacations en sous-effectif',
  'Use a circular geofence centered on the saved site pin.':
    'Utiliser une zone géorepérée circulaire centrée sur le repère enregistré du site.',
  'Use a circular geofence centered on the site pin.':
    'Utiliser une zone géorepérée circulaire centrée sur le repère du site.',
  'Add at least three points to define the site geofence bounds.':
    'Ajoutez au moins trois points pour définir les limites géorepérées du site.',
  'Client name is required': 'Le nom du client est requis',
  'Coverage start and end cannot be the same unless the site is 24-hour coverage.':
    'Les heures de début et de fin de la couverture ne peuvent être identiques que si le site est couvert 24 h/24.',
  'Coverage start and end cannot match unless the site is 24-hour coverage.':
    'Les heures de début et de fin de la couverture ne peuvent coïncider que si le site est couvert 24 h/24.',
  'Create or select a client before adding a site':
    'Créez ou sélectionnez un client avant d’ajouter un site',
  'Failed to archive client': 'Impossible d’archiver le client',
  'Failed to cancel invite': 'Impossible d’annuler l’invitation',
  'Failed to create client': 'Impossible de créer le client',
  'Failed to create site': 'Impossible de créer le site',
  'Failed to delete client': 'Impossible de supprimer le client',
  'Failed to load clients': 'Impossible de charger les clients',
  'Failed to resend invite': 'Impossible de renvoyer l’invitation',
  'Failed to restore client': 'Impossible de restaurer le client',
  'Failed to update client': 'Impossible de mettre à jour le client',
  'Failed to update coverage window': 'Impossible de mettre à jour la plage de couverture',
  'Failed to update site geofence bounds':
    'Impossible de mettre à jour les limites géorepérées du site',
  'Restore this client before resending a portal invite':
    'Restaurez ce client avant de renvoyer une invitation au portail',
  'Restore this client before sending a portal invite':
    'Restaurez ce client avant d’envoyer une invitation au portail',
  'Set the site location before saving a radius geofence.':
    'Définissez l’emplacement du site avant d’enregistrer une zone géorepérée circulaire.',
  'Site name is required': 'Le nom du site est requis',
  'This site needs a saved location before a radius geofence can be used.':
    'Ce site doit avoir un emplacement enregistré avant de pouvoir utiliser une zone géorepérée circulaire.',
  '{name} has been archived.': '{name} a été archivé.',
  '{name} has been permanently deleted with {count} linked site.':
    '{name} a été définitivement supprimé avec {count} site associé.',
  '{name} has been permanently deleted with {count} linked sites.':
    '{name} a été définitivement supprimé avec {count} sites associés.',
  '{name} has been permanently deleted.': '{name} a été définitivement supprimé.',
  '{name} has been restored.': '{name} a été restauré.',
  '{name} has been updated.': '{name} a été mis à jour.',
  'Created {name}. Add sites, then send the client invite when ready.':
    'Client {name} créé. Ajoutez des sites, puis envoyez l’invitation au portail quand tout est prêt.',
  '24 hours': '24 heures',
  '24-hour coverage': 'Couverture 24 h/24',
  'Archive client': 'Archiver le client',
  'Archive instead': 'Archiver plutôt',
  'Archiving {name} hides the client and its linked sites and data from standard views and creation screens. It can be restored later.':
    'L’archivage de {name} masque le client ainsi que ses sites et données liés dans les vues standard et les écrans de création. Il pourra être restauré plus tard.',
  'Archiving...': 'Archivage...',
  'Are you sure? This will permanently delete the site and all associated data (checkpoints, patrols, posts, duty slots, and shifts). This action cannot be undone.':
    'Voulez-vous vraiment continuer ? Cela supprimera définitivement le site et toutes les données associées (points de contrôle, rondes, postes, créneaux de service et vacations). Cette action est irréversible.',
  'Area ready to save': 'Zone prête à enregistrer',
  'Build the boundary point by point': 'Construisez la limite point par point',
  'Could not load coverage data. Please refresh.':
    'Impossible de charger les données de couverture. Veuillez actualiser.',
  'Create Site': 'Créer le site',
  'Create new site': 'Créer un nouveau site',
  'Current site pin: {lat}, {lng}': 'Repère actuel du site : {lat}, {lng}',
  'Delete client permanently': 'Supprimer définitivement le client',
  'Deleting {name} will permanently remove the client contract, portal access, invites, linked sites, schedules, patrols, posts, reports, alarms, shift history, and all associated operational data. This cannot be undone.':
    'La suppression de {name} retirera définitivement le contrat client, l’accès au portail, les invitations, les sites liés, les plannings, les rondes, les postes, les rapports, les alarmes, l’historique des vacations et toutes les données opérationnelles associées. Cette action est irréversible.',
  'Invite resent to {email}.': 'Invitation renvoyée à {email}.',
  'Invite sent to {email}.': 'Invitation envoyée à {email}.',
  'No gap': 'Aucune lacune',
  'No guards assigned': 'Aucun agent assigné',
  'No licence required': 'Aucune licence requise',
  'No licence types available': 'Aucun type de licence disponible',
  'Polygon ready': 'Polygone prêt',
  'Radius {radius} m': 'Rayon {radius} m',
  'Radius {radius} m around the site location':
    'Rayon de {radius} m autour de l’emplacement du site',
  'Resolving address...': 'Résolution de l’adresse...',
  'Restore client': 'Restaurer le client',
  'Restoring {name} makes the client and its linked sites available in standard views and creation screens again.':
    'La restauration de {name} rendra de nouveau le client et ses sites liés disponibles dans les vues standard et les écrans de création.',
  'Restoring...': 'Restauration...',
  'Save coverage window': 'Enregistrer la plage de couverture',
  'Save geofence bounds': 'Enregistrer les limites géorepérées',
  'Select a client to manage its sites.':
    'Sélectionnez un client pour gérer ses sites.',
  'Select a client to view and manage its sites, coverage windows, and geofence boundaries.':
    'Sélectionnez un client pour consulter et gérer ses sites, ses plages de couverture et ses limites géorepérées.',
  'Select a country to load the matching licence types.':
    'Sélectionnez un pays pour charger les types de licence correspondants.',
  'Selected client sites': 'Sites du client sélectionné',
  'Site geofence bounds ({count} point)': 'Limites géorepérées du site ({count} point)',
  'Site geofence bounds ({count} points)': 'Limites géorepérées du site ({count} points)',
  'Site geofence bounds need {count} more point':
    'Les limites géorepérées du site nécessitent encore {count} point',
  'Site geofence bounds need {count} more points':
    'Les limites géorepérées du site nécessitent encore {count} points',
  'Site geofence bounds with {count} point':
    'Limites géorepérées du site avec {count} point',
  'Site geofence bounds with {count} points':
    'Limites géorepérées du site avec {count} points',
  'Site location': 'Emplacement du site',
  'The pending invite has been cancelled.':
    'L’invitation en attente a été annulée.',
  'This becomes the default licence requirement for duties created at this site.':
    'Cette licence devient l’exigence par défaut pour les services créés sur ce site.',
  'This site does not have a saved pin. Switch to geofence bounds or update the site location first.':
    'Ce site n’a pas de repère enregistré. Passez aux limites géorepérées ou mettez d’abord à jour l’emplacement du site.',
  'Timezone': 'Fuseau horaire',
  'Unknown site': 'Site inconnu',
  'Untitled shift': 'Vacation sans titre',
  'Updated coverage window for {name}.':
    'Plage de couverture mise à jour pour {name}.',
  'Updated geofence bounds for {name}.':
    'Limites géorepérées mises à jour pour {name}.',
  'Vertex {number}': 'Sommet {number}',
  '{count} more needed': '{count} supplémentaires nécessaires',
  '{count} sites total': '{count} sites au total',
  '{count} vertex': '{count} sommet',
  '{count} vertices': '{count} sommets',
  '{hours}h gap': 'lacune de {hours} h',
  '{name} location': 'Emplacement de {name}',
  '{percent}% average': '{percent} % en moyenne',
  '{startDate} {startTime} to {endDate} {endTime}':
    'du {startDate} {startTime} au {endDate} {endTime}',
  '{status}: {percent}% covered, {duration} uncovered':
    '{status} : {percent} % couvert, {duration} non couvert',
  '{count} site': '{count} site',
  '{count} sites': '{count} sites',
  // Site builder (multi-step create flow)
  'Add {count} more point': 'Ajoutez encore {count} point',
  'Add {count} more points': 'Ajoutez encore {count} points',
  'Boundary': 'Limites',
  'Boundary ready': 'Limites prêtes',
  'Bounds': 'Polygone',
  'Centre': 'Centre',
  'Check the details, then create the site.': 'Vérifiez les informations, puis créez le site.',
  'Clear all points?': 'Effacer tous les points ?',
  'Click the map to drop the site pin': 'Cliquez sur la carte pour placer le repère du site',
  'Click to add a point · drag to move · right-click to delete':
    'Cliquez pour ajouter un point · glissez pour déplacer · clic droit pour supprimer',
  'Continue': 'Continuer',
  'Cover runs between a start and end time each day.':
    'La couverture s’étend d’une heure de début à une heure de fin chaque jour.',
  'Covers': 'Superficie',
  'Created {name}.': '{name} a été créé.',
  'Defaults for every shift here. Individual shifts can still override them.':
    'Valeurs par défaut pour chaque vacation ici. Chaque vacation peut toujours les remplacer.',
  'Discard': 'Abandonner',
  'Discard this site?': 'Abandonner ce site ?',
  'Drag the pin to move the centre': 'Glissez le repère pour déplacer le centre',
  'Draw the site boundary': 'Tracez les limites du site',
  'Duty board slots can only be created inside this window.':
    'Les créneaux du tableau de service ne peuvent être créés que dans cette plage.',
  'Duty rules': 'Règles de service',
  'Duty rules for this site': 'Règles de service pour ce site',
  'Filled in from the search or map pin':
    'Renseignée depuis la recherche ou le repère sur la carte',
  'Fit to boundary': 'Ajuster aux limites',
  'Fixed window': 'Plage fixe',
  'Guards are judged in or out of this area, so keep it tight to the real perimeter.':
    'Les agents sont jugés à l’intérieur ou à l’extérieur de cette zone : restez au plus près du périmètre réel.',
  'Keep editing': 'Continuer la modification',
  'Mode': 'Mode',
  'Name the site and pin it on the map. Everything else follows from this.':
    'Nommez le site et placez-le sur la carte. Tout le reste en découle.',
  'No pin yet — you can also drop one on the boundary step.':
    'Aucun repère pour l’instant — vous pouvez aussi en placer un à l’étape des limites.',
  'Pinned at {lat}, {lng}': 'Repère placé à {lat}, {lng}',
  'Radius geofence': 'Géorepérage par rayon',
  'Ready': 'Prêt',
  'Review and create': 'Vérifier et créer',
  'Site name': 'Nom du site',
  'Site setup steps': 'Étapes de configuration du site',
  'Size': 'Taille',
  'Step {current} of {total}': 'Étape {current} sur {total}',
  'The country decides which licence types and timezone apply.':
    'Le pays détermine les types de licence et le fuseau horaire applicables.',
  'The site must be manned around the clock.': 'Le site doit être gardé 24 h/24.',
  'Vertices': 'Sommets',
  'When does this site need cover?': 'Quand ce site doit-il être couvert ?',
  'Where is this site?': 'Où se trouve ce site ?',
  'e.g. Riverside Distribution Centre': 'ex. Centre de distribution Riverside',
  '{count} step of detail will be lost.': '{count} étape de détails sera perdue.',
  '{count} steps of detail will be lost.': '{count} étapes de détails seront perdues.',
  // Site builder (edit mode)
  'Check the details, then save your changes.':
    'Vérifiez les informations, puis enregistrez vos modifications.',
  'Review your changes': 'Vérifier vos modifications',
  'Discard your changes?': 'Abandonner vos modifications ?',
  'Edit boundary': 'Modifier les limites',
  'Edit site': 'Modifier le site',
  'Failed to update site': 'Impossible de mettre à jour le site',
  'Save changes': 'Enregistrer les modifications',
  'This site will keep its saved details.': 'Ce site conservera ses informations enregistrées.',
  'Updated {name}.': '{name} a été mis à jour.',
  'Creating…': 'Création…',
  'Open Post Builder': 'Ouvrir le générateur de postes',
  'Post Builder': 'Générateur de postes',
  'Place and manage fixed guard posts and their geofences for any site.':
    'Placez et gérez les postes de garde fixes et leurs géorepérages pour chaque site.',
  'Site directory': 'Répertoire des sites',
  'Every location you cover, with its boundary, cover window and duty rules on one screen.':
    'Tous les lieux que vous couvrez, avec leur périmètre, leur plage de couverture et leurs règles de service sur un seul écran.',
  'All clients': 'Tous les clients',
  'No client linked': 'Aucun client rattaché',
  'Filter by client': 'Filtrer par client',
  'Filter by client: {name}': 'Filtrer par client : {name}',
  'Clear client filter': 'Effacer le filtre client',
  'Find a client…': 'Trouver un client…',
  'Search sites, addresses or clients…': 'Rechercher un site, une adresse ou un client…',
  'across {count} client': 'pour {count} client',
  'across {count} clients': 'pour {count} clients',
  'Round-the-clock': '24 h/24',
  'Manned 24 hours a day': 'Gardé 24 heures sur 24',
  'Cover between set hours': 'Couverture sur des heures fixes',
  'Needs setup': 'À configurer',
  'Missing a pin, boundary or address': 'Sans repère, périmètre ou adresse',
  'Cover window {window}': 'Plage de couverture {window}',
  'No map pin': 'Aucun repère sur la carte',
  'Boundary unfinished': 'Périmètre incomplet',
  'No address': 'Aucune adresse',
  'No address on file': 'Aucune adresse enregistrée',
  'Add site': 'Ajouter un site',
  'Add the first site': 'Ajouter le premier site',
  'Add a site to {name}': 'Ajouter un site à {name}',
  'Which client is this site for?': 'Pour quel client est ce site ?',
  'Delete {name}': 'Supprimer {name}',
  'No sites yet': 'Aucun site pour l’instant',
  'A site holds the boundary guards are judged against, the hours it must be manned, and the licence its duties require.':
    'Un site regroupe le périmètre sur lequel les agents sont évalués, les heures pendant lesquelles il doit être gardé et la licence exigée par ses missions.',
  'Create a client contract first — every site is linked to one.':
    'Créez d’abord un contrat client : chaque site est rattaché à l’un d’eux.',
  'Nothing matches these filters': 'Aucun résultat pour ces filtres',
  'Try a different client, clear the search, or reset the filters to see every site again.':
    'Essayez un autre client, effacez la recherche ou réinitialisez les filtres pour revoir tous les sites.',
  'These sites predate client contracts and are hidden from the client portal.':
    'Ces sites sont antérieurs aux contrats clients et n’apparaissent pas dans le portail client.',
  'Waiting on their first site': 'En attente de leur premier site',
  'These clients are signed up but have nowhere to roster guards yet.':
    'Ces clients sont enregistrés mais n’ont encore aucun lieu où planifier des agents.',
  'Need to add or edit clients?': 'Besoin d’ajouter ou de modifier des clients ?',
  'A client contract sits at the top of the chain: sites hang off it and the portal invite goes to its contact. The name is all you need to start.':
    'Le contrat client est le point de départ : les lieux s’y rattachent et l’invitation au portail part vers son contact. Le nom suffit pour commencer.',
  'Access quirks, escalation rules, anything the team should know…':
    'Particularités d’accès, règles d’escalade, tout ce que l’équipe doit savoir…',
  'Add a contact email before sending the invite':
    'Ajoutez un e-mail de contact avant d’envoyer l’invitation',
  'Billing email': 'E-mail de facturation',
  'Cancel invite': 'Annuler l’invitation',
  'Client can sign in and watch their sites': 'Le client peut se connecter et suivre ses lieux',
  'Client name *': 'Nom du client *',
  'Contact email': 'E-mail du contact',
  'Contact name': 'Nom du contact',
  'Contact phone': 'Téléphone du contact',
  'Contact, billing and notes': 'Contact, facturation et notes',
  'Delete client': 'Supprimer le client',
  'Edit client': 'Modifier le client',
  'Edit {name}': 'Modifier {name}',
  'Every client under contract, what each is waiting on, and the next step.':
    'Tous les clients sous contrat, ce que chacun attend et la prochaine étape.',
  'Include archived': 'Inclure les archivés',
  'Internal notes': 'Notes internes',
  'Invite email': 'E-mail d’invitation',
  'Invite sent to {email}': 'Invitation envoyée à {email}',
  'Invite sent to {email}, expires {date}': 'Invitation envoyée à {email}, expire le {date}',
  'Missing an invite email or a site': 'Sans e-mail d’invitation ou sans lieu',
  'More actions for {name}': 'Autres actions pour {name}',
  'Never shown to the client.': 'Jamais visible par le client.',
  'New client': 'Nouveau client',
  'No clients match': 'Aucun client ne correspond',
  'No clients yet': 'Aucun client pour le moment',
  'No invite email': 'Pas d’e-mail d’invitation',
  'Nothing here matches the current search and filters.':
    'Rien ne correspond à la recherche et aux filtres actuels.',
  'Only needed when invoices go somewhere other than the contact above.':
    'Utile uniquement si les factures partent ailleurs que vers le contact ci-dessus.',
  'Only the client name is required — you can fill in the rest at any time.':
    'Seul le nom du client est obligatoire — le reste peut être complété à tout moment.',
  'Only the client name is required. Clear a field to remove it.':
    'Seul le nom du client est obligatoire. Videz un champ pour le supprimer.',
  'Optional': 'Facultatif',
  'Portal live': 'Portail actif',
  'Resend invite': 'Renvoyer l’invitation',
  'Resending…': 'Renvoi…',
  'Riverside Retail Park': 'Parc commercial des Rives',
  'Search clients, contacts or emails…': 'Rechercher un client, un contact ou un e-mail…',
  'Send invite': 'Envoyer l’invitation',
  'Sending…': 'Envoi…',
  'Sent, waiting on the client': 'Envoyée, en attente du client',
  'The portal invite is sent here. Leave it blank and add it when you know it.':
    'L’invitation au portail part à cette adresse. Laissez vide et ajoutez-la plus tard.',
  'Who you deal with day to day': 'Votre interlocuteur au quotidien',
  '{count} site under contract': '{count} lieu sous contrat',
  '{count} sites under contract': '{count} lieux sous contrat',
  'Enter how many guards the site needs at once, from 1 to {max}.': 'Indiquez combien d’agents le site requiert en même temps, de 1 à {max}.',
  'How many guards must be on site at every moment of the coverage window. Auto scheduling drafts a post for each one.': 'Le nombre d’agents qui doivent être présents sur le site à tout moment de la plage de couverture. La planification automatique crée un poste pour chacun.',
  'Minimum guards': 'Agents minimum',
  'Minimum guards on site': 'Agents minimum sur site',
  'Minimum guards on site *': 'Agents minimum sur site *',
};
